import { ProductScreenshot } from 'components/ProductScreenshot';
import annotationLight from "../../../../contents/images/features/annotations/annotation-hn-light-mode.png";
import annotationDark from "../../../../contents/images/features/annotations/annotation-hn-dark-mode.png";
import { ProductVideo } from 'components/ProductVideo';
import createAnnotationLight from "../../../../contents/images/features/annotations/create-annotation-light-mode.mp4";
import createAnnotationDark from "../../../../contents/images/features/annotations/create-annotation-dark-mode.mp4";
import * as React from 'react';
export default {
  ProductScreenshot,
  annotationLight,
  annotationDark,
  ProductVideo,
  createAnnotationLight,
  createAnnotationDark,
  React
};